/* Keep prices, variant names and inquiry links in sync without navigating the editor iframe. */
if (!customElements.get('gridone-catalog-product')) {
  customElements.define('gridone-catalog-product', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const select = this.querySelector('select[name="variant"]');
      if (!select) return;
      const update = () => {
        const option = select.options[select.selectedIndex];
        if (!option) return;
        this.querySelector('[data-variant-title]').textContent = option.dataset.title;
        this.querySelector('[data-variant-price]').textContent = option.dataset.price;
        const compare = this.querySelector('[data-variant-compare]');
        compare.textContent = option.dataset.compare || '';
        compare.hidden = !option.dataset.compare;
        const link = this.querySelector('[data-product-inquiry]');
        const url = new URL(link.href, window.location.origin);
        url.searchParams.set('produkt', `${this.dataset.productTitle} — ${option.dataset.title}`);
        link.href = url.href;
        if (!window.Shopify?.designMode) {
          const page = new URL(window.location.href);
          page.searchParams.set('variant', option.value);
          window.history.replaceState(null, '', page);
        }
      };
      select.addEventListener('change', update, {signal:this.controller.signal});
      select.form.addEventListener('submit', event => {event.preventDefault(); update();}, {signal:this.controller.signal});
      this.querySelector('[data-variant-submit]').hidden = true;
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
